/* ============================================================
   STINCHFIELD BROADCAST THEME — theme JS
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toastEl = document.createElement('div');
  toastEl.className = 'sf-toast';
  toastEl.setAttribute('role', 'status');
  document.body.appendChild(toastEl);
  var toastTimer;
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('sf-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('sf-show'); }, 2400);
  }

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-sf-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  function addToCart(variantId, qty, btn) {
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { toast('Added to cart'); refreshCartCount(); })
      .catch(function () { toast('Could not add to cart'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  }

  /* ---------- Variant matching ---------- */
  function wireVariantPicker(root) {
    var dataEl = root.querySelector('[data-sf-variants]');
    if (!dataEl) return null;
    var variants = JSON.parse(dataEl.textContent);
    var selects = root.querySelectorAll('[data-sf-option]');

    function current() {
      if (!selects.length) return variants[0];
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }
    return { current: current, selects: selects, variants: variants };
  }

 /* ---------- Quick-add cards ---------- */
  document.querySelectorAll('[data-sf-product]').forEach(function (card) {
    var addBtn = card.querySelector('[data-sf-add]');
    if (!addBtn) return;
    var picker = wireVariantPicker(card);
    if (!picker) return;

    var cardImg = card.querySelector('[data-sf-main-img]');
    var cardPrice = card.querySelector('[data-sf-price]');

    function sync() {
      var v = picker.current();
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      else if (!v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
      else { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }

      if (v && cardImg && v.image) {
        var pic = cardImg.closest('picture');
        if (pic) { pic.querySelectorAll('source').forEach(function (s) { s.remove(); }); }
        cardImg.removeAttribute('srcset');
        cardImg.src = v.image;
      }
      if (v && cardPrice && v.price_formatted) { cardPrice.textContent = v.price_formatted; }
    }
    picker.selects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();

    addBtn.addEventListener('click', function () {
      var v = picker.current();
      if (v && v.available) addToCart(v.id, 1, addBtn);
    });
  });

  /* ---------- Product page ---------- */
  var pp = document.querySelector('[data-sf-main-product]');
  if (pp) {
    var picker = wireVariantPicker(pp);
    var priceEl = pp.querySelector('[data-sf-price]');
    var compareEl = pp.querySelector('[data-sf-compare]');
    var buyBtn = pp.querySelector('[data-sf-buy]');
    var qtyInput = pp.querySelector('[data-sf-qty]');
    var idInput = pp.querySelector('[data-sf-id]');
    var mainImg = pp.querySelector('[data-sf-main-img]');

    function syncProduct() {
      if (!picker) return;
      var v = picker.current();
      if (!v) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
      if (compareEl) {
        if (v.compare_formatted) { compareEl.textContent = v.compare_formatted; compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      if (buyBtn) {
        if (v.available) { buyBtn.disabled = false; buyBtn.textContent = 'Add to cart'; }
        else { buyBtn.disabled = true; buyBtn.textContent = 'Sold out'; }
      }
      if (mainImg && v.image) { mainImg.src = v.image; }
    }
    if (picker) {
      picker.selects.forEach(function (s) { s.addEventListener('change', syncProduct); });
      syncProduct();
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var v = picker ? picker.current() : null;
        if (!v || !v.available) return;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        addToCart(v.id, qty, buyBtn);
      });
    }

    /* gallery thumbs */
    pp.querySelectorAll('[data-sf-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.dataset.sfThumb;
        pp.querySelectorAll('[data-sf-thumb]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === t);
        });
      });
    });
  }

  refreshCartCount();
})();
